import dynamic from "next/dynamic";
import { getGalleryCategoryUrl, getGalleryPatientUrl } from "@/lib/gallery";

const Link = dynamic(() => import("@/components/ui/Link"));
const BeforeAfterGallery = dynamic(() => import("../PatientCarousel"));
const OtherPatientsCarousel = dynamic(() => import("../OtherPatientsCarousel"));
const BreadCrumbs = dynamic(() => import("../BreadCrumbs"));

interface PatientSectionProps {
  data: {
    procedure: any;
    patient: any;
    patients: any;
  };
}

export default function PatientSection({ data }: PatientSectionProps) {
  const { procedure, patient, patients } = data;
  
  // Find current patient index
  const currentIndex = patients.findIndex(p => p.id === patient.id);
  const prevPatient = currentIndex > 0 ? patients[currentIndex - 1] : null;
  const nextPatient = currentIndex < patients.length - 1 ? patients[currentIndex + 1] : null;

  return (
    <section id="PatientSection" className="mx-auto px-8 lg:px-16 py-5 md:py-10 bg-white">
      <div className="mb-8 md:mb-16">
        <BreadCrumbs className="text-xs md:text-base text-blue-950 font-greycliff" segments={[
          { 
            title: procedure.title, 
            url: getGalleryCategoryUrl(procedure.slug) 
          },
          { 
            title: patient.title, 
          }
        ]} />

        <div id="patient" className="flex flex-col md:flex-row justify-between items-center py-8 md:py-16">
          <Link href={getGalleryCategoryUrl(procedure.slug)} className="w-full md:w-auto mb-6 md:mb-0">
            <div className="h-16 px-6 md:px-12 py-2.5 rounded-[3.125rem] border border-blue-950 md:bg-white bg-blue-950 flex justify-center items-center">
              <span className="text-sm md:text-xl font-greycliff md:text-blue-950 text-white tracking-tight">
                Back to Gallery
              </span>
            </div>
          </Link>

          <div className="flex gap-5 w-full md:w-auto">
            {prevPatient && (
              <Link href={`${getGalleryPatientUrl(procedure.slug, prevPatient.id) || "#"}#patient`} className="flex-1 md:flex-none">
                <div className="h-16 px-0 md:px-12 py-2.5 rounded-[3.125rem] border border-blue-950 flex justify-center items-center">
                  <span className="text-sm md:text-xl font-greycliff text-blue-950 tracking-tight text-center md:text-left">
                    Previous Patient
                  </span>
                </div>
              </Link>
            )}
            {nextPatient && (
              <Link href={`${getGalleryPatientUrl(procedure.slug, nextPatient.id) || "#"}#patient`} className="flex-1 md:flex-none">
                <div className="h-16 px-0 md:px-12 py-2.5 rounded-[3.125rem] border border-blue-950 bg-blue-950 flex justify-center items-center">
                  <span className="text-sm md:text-xl font-greycliff text-white tracking-tight">
                    Next Patient
                  </span>
                </div>
              </Link>
            )}
          </div>
        </div>
        <BeforeAfterGallery procedureTitle={procedure.title} patient={patient} />
        <OtherPatientsCarousel patients={patients} procedureSlug={procedure.slug} />
      </div>
    </section>
  );
}
